import { render, staticRenderFns } from "./levelstage.vue?vue&type=template&id=99e3340e&scoped=true"
import script from "./levelstage.vue?vue&type=script&lang=js"
export * from "./levelstage.vue?vue&type=script&lang=js"
import style0 from "./levelstage.vue?vue&type=style&index=0&id=99e3340e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e3340e",
  null
  
)

export default component.exports